import React, { Component } from "react";
import Button from "react-bootstrap-button-loader";
import Dropzone from "react-dropzone";
import LocaleStrings from "Languages";

export default class AllFilesDrop extends Component {
  constructor(props) {
    super(props);

    this.imageCallback = null;

    this.state = {
      imagePreviewUrl: props.imagePreviewUrl,
      filepath: props.filepath,
    };
    this.resetImage = this.resetImage.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps) {
      if (nextProps.filepath !== "" && this.state.filepath === "") {
        this.setState({ filepath: nextProps.filepath });
      }
    }
  }

  onDropFile = (files) => {
    var that = this;
    let file = files[0];

    let reader = new FileReader();
    reader.onloadend = () => {
      var item = reader.result;
      var data = { file: item, filename: file.name.replace(/ /g, "-") };
      that.props.onFileSave(data);
      that.props.onFileChnageLocally(true);
    };
    reader.readAsDataURL(file);
  };

  resetImage = () => {
    this.setState({ filepath: "" });
    this.props.onFileSave("");
    this.props.onFileChnageLocally(true);
  };

  render() {
    let fileUrl = this.state.filepath;
    let { fileName, fileOld, accept, insideText } = this.props;

    var hideDropZoneClass = "";
    var hideControlButton = "hide-feature";

    if (fileUrl && fileUrl !== "file object not found") {
      hideDropZoneClass = "hide-feature";
      hideControlButton = "";
    }

    let icon = "../../style/images/file_document.svg";
    if (fileName != "") {
      var fileType = fileName.split(".").pop();

      if (
        fileType == "svg" ||
        fileType == "png" ||
        fileType == "jpg" ||
        fileType == "jpeg"
      ) {
        icon = "../../style/images/file_image.svg";
      }
    }

    return (
      <div className="">
        <Dropzone
          onDrop={this.onDropFile}
          accept={accept ? accept : ""}
          multiple={false}
        >
          {({ getRootProps, getInputProps }) => (
            <div
              {...getRootProps()}
              className={`${this.props.className} ${hideDropZoneClass}`}
            >
              <input {...getInputProps()} />
              {insideText}
            </div>
          )}
        </Dropzone>

        <div className={`attachment-files-displaybox ${hideControlButton}`}>
          <div className="row m-0">
            <div className="col-md-1 p-0 text-center">
              <img className="file-icon" src={`${icon}`} alt="" />
            </div>
            <div className="col-md-9 p-0 custom-text3-normal">
              <div className="file-name">{fileName}</div>
            </div>
            <div className="col-md-2 p-0 text-right">
              {fileOld ? (
                <a
                  className="action-icons"
                  href={`${fileUrl}&download=true`}
                  title="Download"
                >
                  <img
                    className="pointer"
                    src={`../../style/images/icons_circle_down.svg`}
                    alt=""
                  />
                </a>
              ) : (
                ""
              )}
              <img
                onClick={this.resetImage}
                className="file-delete-button action-icons pointer"
                src={`../../style/images/trash_icon_xs.png`}
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
